export function getAssetUrl(id){
    if(!id) return null;

    return `${process.env.NEXT_PUBLIC_DIRECTUS_FRONT_URL_DOCUMENT}${id}`;
}